<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-subsection" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Update
                </div>
                <div class="modal-body pb-0">
                    <div class="container-fluid">

                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Namn" id="Namn" name="name" v-model="name" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="resursnamn" id="resourceName" name="resourceName" v-model="resourceName" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined"  label="Färg" :items="['','blue','green','lime','orange','purple']" v-model="color"></v-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <v-textarea label="textContent" v-model="textContent" variant="outlined"></v-textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col mb-3">
                                <v-btn color="primary"
                                       variant="text"
                                       @click="removeTopNode">
                                    Remove top node
                                </v-btn>
                                <v-btn color="primary"
                                       variant="text"
                                       @click="formatImage">
                                    formatImage
                                </v-btn>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col">
                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel>
                                        <v-expansion-panel-title>
                                            Info
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <v-text-field bg-color="white" label="sortIndex" id="sortIndex" name="sortIndex" v-model="sortIndex" variant="outlined"></v-text-field>
                                                </div>
                                                <div class="row">
                                                    <v-text-field bg-color="white" disabled="true" label="moduleId" id="moduleId" name="moduleId" v-model="moduleId" variant="outlined"></v-text-field>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-text-field bg-color="white" label="parentId" id="parentId" name="parentId" v-model="parentId" variant="outlined"></v-text-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-text-field bg-color="white" disabled="true" label="subSectionId" id="subSectionId" name="subSectionId" v-model="subSectionId" variant="outlined"></v-text-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-text-field bg-color="white" label="component" id="component" name="component" v-model="component" variant="outlined"></v-text-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Close
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Save
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ModuleService from "../../Services/ModuleService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['subsectionupdated'],
        name: 'update-subsection',
        props: {

        },
        methods: {
            filterNonAscii() {
                var filtered = this.name.replaceAll(" ", "_");
                filtered = filtered.replaceAll("ä", "a");
                filtered = filtered.replaceAll("Ä", "a");
                filtered = filtered.replaceAll("å", "a");
                filtered = filtered.replaceAll("Å", "a");
                filtered = filtered.replaceAll("ö", "o");
                filtered = filtered.replaceAll("Ö", "o");
                filtered = filtered.replaceAll("?", "");
                filtered = filtered.replaceAll("é", "e");
                filtered = filtered.replaceAll("É", "e");
                filtered = filtered.split(".").join("_");
                filtered = filtered.split("-").join("_");
                filtered = filtered.split("(").join("_");
                filtered = filtered.split(")").join("_");
                filtered = filtered.split(",").join("_");
                filtered = filtered.split("&").join("_");
                filtered = filtered.split("/").join("_");
                filtered = filtered.toLowerCase();
                this.resourceName = filtered;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            removeTopNode() {
                if (this.textContent != "") {
                    var mySubString = this.textContent.split('auto; overflow: auto;">').pop();
                    mySubString = mySubString.substring(0, mySubString.lastIndexOf("</div>"));
                    this.textContent = mySubString;
                }
            },
            formatImage() {
                if (this.textContent != "") {
                    this.textContent = this.textContent.replaceAll("../gfx", "/images")
                }
            }, 
            close() {
                this.resetAll();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                if (this.subSectionId == -1) {
                    await ModuleService.addSubSection(this.moduleId, this.parentId, this.name, this.resourceName, this.color, this.selectedColor, this.textContent, this.sortIndex, this.component);
                }
                else {
                    await ModuleService.updateSubSection(this.subSectionId, this.name, this.resourceName, this.color, this.selectedColor, this.textContent, this.sortIndex, this.component, this.parentId);
                }

                this.$emit("subsectionupdated");   

                if (this.subSectionId == -1) {
                    this.dialogueVisible = false;
                    this.thisModal.hide();
                }
                 
                this.reset();
               
            },
            open(item) {
                this.resetAll();
                this.name = item.Name;
                this.component = item.Component;
                this.subSectionId = item.SubSectionId;
                this.moduleId = item.ModuleId;
                this.sortIndex = item.SortIndex;
                this.name = item.Name;
                this.resourceName = item.ResourceName;
                this.color = item.Color;
                this.selectedcolor = item.Selectedcolor;
                this.textContent = item.TextContent;
                this.parentId = item.ParentId;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create(parentId, moduleId) {
                this.resetAll();
                this.parentId = parentId;
                this.moduleId = moduleId;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            resetAll() {
                this.moduleId = -1;
                this.parentId = -1;
                this.subSectionId = -1;
                this.name = "";
                this.resourceName = "";
                //this.color = "";
                this.selectedcolor = "";
                this.textContent = "";
                this.sortIndex = 0;
                this.component = "";
            },
            reset() {
                this.name = "";
                this.resourceName = "";
                //this.color = "";
                this.selectedcolor = "";
                this.textContent = "";
                this.component = "";
                this.sortIndex = 0;
            },
        },
        data() {
            return {
                dialogueVisible: false,
                
                subSectionId: -1,
                moduleId: -1,
                thisModal: {},
                name: "",
                resourceName: "",
                color: "",
                selectedcolor: "",
                textContent: "",
                parentId: -1,
                sortIndex: 0,
                component: "",

            };
        },
        watch: {
            name: function () {
                this.filterNonAscii();
            },
        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});
        },
        //setup(props, { emit }) {
            //emit('subsectionupdated')
        //}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
